import { StockItem, LocationQuantity } from "@/types/stock-item";
import { getTransactionCount } from "./mockTransactions";

// Generate 50+ mock stock items with barcodes
export const generateMockStockItems = (): StockItem[] => {
  // Temporary interface for initial data with location string
  interface TempItem {
    code: string;
    description: string;
    category: string;
    location: string;
    physicalQuantity: number;
    unitPrice: number;
    inactive: boolean;
    barcode: string;
  }

  const items: TempItem[] = [
    {
      code: "STK001",
      description: "Laptop Dell XPS 15",
      category: "Electronics",
      location: "Warehouse A",
      physicalQuantity: 45,
      unitPrice: 1299.99,
      inactive: false,
      barcode: "5901234123457",
    },
    {
      code: "STK002",
      description: "Office Chair Ergonomic",
      category: "Furniture",
      location: "Warehouse B",
      physicalQuantity: 120,
      unitPrice: 249.5,
      inactive: false,
      barcode: "5901234123464",
    },
    {
      code: "STK003",
      description: "A4 Paper Ream (500 sheets)",
      category: "Office Supplies",
      location: "Warehouse A",
      physicalQuantity: 450,
      unitPrice: 5.99,
      inactive: false,
      barcode: "5901234123471",
    },
    {
      code: "STK004",
      description: "Steel Rods 10mm x 6m",
      category: "Raw Materials",
      location: "Distribution Center",
      physicalQuantity: 200,
      unitPrice: 45.75,
      inactive: false,
      barcode: "5901234123488",
    },
    {
      code: "STK005",
      description: "Wireless Mouse Logitech",
      category: "Electronics",
      location: "Retail Store",
      physicalQuantity: 85,
      unitPrice: 29.99,
      inactive: false,
      barcode: "5901234123495",
    },
    {
      code: "STK006",
      description: "Standing Desk Adjustable",
      category: "Furniture",
      location: "Warehouse B",
      physicalQuantity: 35,
      unitPrice: 599.0,
      inactive: false,
      barcode: "5901234123501",
    },
    {
      code: "STK007",
      description: "Ballpoint Pens Blue (Box of 50)",
      category: "Office Supplies",
      location: "Warehouse A",
      physicalQuantity: 300,
      unitPrice: 12.5,
      inactive: false,
      barcode: "5901234123518",
    },
    {
      code: "STK008",
      description: "Aluminum Sheets 2mm",
      category: "Raw Materials",
      location: "Warehouse C",
      physicalQuantity: 150,
      unitPrice: 89.99,
      inactive: true,
      barcode: "5901234123525",
    },
    {
      code: "STK009",
      description: 'Monitor 27" 4K Dell',
      category: "Electronics",
      location: "Warehouse A",
      physicalQuantity: 60,
      unitPrice: 449.99,
      inactive: false,
      barcode: "5901234123532",
    },
    {
      code: "STK010",
      description: "Filing Cabinet 4-Drawer",
      category: "Furniture",
      location: "Warehouse B",
      physicalQuantity: 40,
      unitPrice: 189.99,
      inactive: false,
      barcode: "5901234123549",
    },
    {
      code: "STK011",
      description: "Stapler Heavy Duty",
      category: "Office Supplies",
      location: "Retail Store",
      physicalQuantity: 95,
      unitPrice: 18.99,
      inactive: false,
      barcode: "5901234123556",
    },
    {
      code: "STK012",
      description: "Copper Wire 2.5mm",
      category: "Raw Materials",
      location: "Distribution Center",
      physicalQuantity: 500,
      unitPrice: 3.25,
      inactive: false,
      barcode: "5901234123563",
    },
    {
      code: "STK013",
      description: "Keyboard Mechanical RGB",
      category: "Electronics",
      location: "Warehouse A",
      physicalQuantity: 70,
      unitPrice: 129.99,
      inactive: false,
      barcode: "5901234123570",
    },
    {
      code: "STK014",
      description: "Conference Table 8-Seater",
      category: "Furniture",
      location: "Warehouse B",
      physicalQuantity: 12,
      unitPrice: 899.0,
      inactive: false,
      barcode: "5901234123587",
    },
    {
      code: "STK015",
      description: "Sticky Notes 3x3 (Pack of 12)",
      category: "Office Supplies",
      location: "Warehouse A",
      physicalQuantity: 280,
      unitPrice: 8.99,
      inactive: false,
      barcode: "5901234123594",
    },
    {
      code: "STK016",
      description: "PVC Pipes 50mm x 3m",
      category: "Raw Materials",
      location: "Warehouse C",
      physicalQuantity: 180,
      unitPrice: 15.5,
      inactive: false,
      barcode: "5901234123600",
    },
    {
      code: "STK017",
      description: "Webcam HD 1080p",
      category: "Electronics",
      location: "Retail Store",
      physicalQuantity: 55,
      unitPrice: 79.99,
      inactive: false,
      barcode: "5901234123617",
    },
    {
      code: "STK018",
      description: "Bookshelf 5-Tier",
      category: "Furniture",
      location: "Warehouse B",
      physicalQuantity: 65,
      unitPrice: 149.99,
      inactive: false,
      barcode: "5901234123624",
    },
    {
      code: "STK019",
      description: "Printer Paper A3 (250 sheets)",
      category: "Office Supplies",
      location: "Warehouse A",
      physicalQuantity: 220,
      unitPrice: 9.99,
      inactive: false,
      barcode: "5901234123631",
    },
    {
      code: "STK020",
      description: "Timber Planks Oak 2x4",
      category: "Raw Materials",
      location: "Distribution Center",
      physicalQuantity: 300,
      unitPrice: 12.75,
      inactive: false,
      barcode: "5901234123648",
    },
    {
      code: "STK021",
      description: "USB-C Hub 7-Port",
      category: "Electronics",
      location: "Warehouse A",
      physicalQuantity: 90,
      unitPrice: 45.99,
      inactive: false,
      barcode: "5901234123655",
    },
    {
      code: "STK022",
      description: "Desk Lamp LED Adjustable",
      category: "Furniture",
      location: "Retail Store",
      physicalQuantity: 110,
      unitPrice: 34.99,
      inactive: false,
      barcode: "5901234123662",
    },
    {
      code: "STK023",
      description: "Whiteboard Markers (Set of 8)",
      category: "Office Supplies",
      location: "Warehouse A",
      physicalQuantity: 175,
      unitPrice: 14.99,
      inactive: false,
      barcode: "5901234123679",
    },
    {
      code: "STK024",
      description: "Stainless Steel Bolts M8",
      category: "Raw Materials",
      location: "Warehouse C",
      physicalQuantity: 1000,
      unitPrice: 0.45,
      inactive: false,
      barcode: "5901234123686",
    },
    {
      code: "STK025",
      description: "External SSD 1TB Samsung",
      category: "Electronics",
      location: "Warehouse A",
      physicalQuantity: 40,
      unitPrice: 149.99,
      inactive: false,
      barcode: "5901234123693",
    },
    {
      code: "STK026",
      description: "Office Partition Panel",
      category: "Furniture",
      location: "Warehouse B",
      physicalQuantity: 50,
      unitPrice: 199.0,
      inactive: true,
      barcode: "5901234123709",
    },
    {
      code: "STK027",
      description: "Envelope C5 (Box of 500)",
      category: "Office Supplies",
      location: "Warehouse A",
      physicalQuantity: 160,
      unitPrice: 19.99,
      inactive: false,
      barcode: "5901234123716",
    },
    {
      code: "STK028",
      description: "Plastic Granules HDPE",
      category: "Raw Materials",
      location: "Distribution Center",
      physicalQuantity: 400,
      unitPrice: 2.85,
      inactive: false,
      barcode: "5901234123723",
    },
    {
      code: "STK029",
      description: "Headset Wireless Noise-Cancelling",
      category: "Electronics",
      location: "Retail Store",
      physicalQuantity: 75,
      unitPrice: 199.99,
      inactive: false,
      barcode: "5901234123730",
    },
    {
      code: "STK030",
      description: "Storage Cabinet Metal",
      category: "Furniture",
      location: "Warehouse B",
      physicalQuantity: 30,
      unitPrice: 279.99,
      inactive: false,
      barcode: "5901234123747",
    },
    {
      code: "STK031",
      description: "Correction Tape (Pack of 10)",
      category: "Office Supplies",
      location: "Warehouse A",
      physicalQuantity: 140,
      unitPrice: 11.99,
      inactive: false,
      barcode: "5901234123754",
    },
    {
      code: "STK032",
      description: "Rubber Sheets 5mm",
      category: "Raw Materials",
      location: "Warehouse C",
      physicalQuantity: 90,
      unitPrice: 35.5,
      inactive: false,
      barcode: "5901234123761",
    },
    {
      code: "STK033",
      description: 'Tablet iPad 10.2"',
      category: "Electronics",
      location: "Warehouse A",
      physicalQuantity: 35,
      unitPrice: 449.0,
      inactive: false,
      barcode: "5901234123778",
    },
    {
      code: "STK034",
      description: "Visitor Chair Stackable",
      category: "Furniture",
      location: "Warehouse B",
      physicalQuantity: 200,
      unitPrice: 79.99,
      inactive: false,
      barcode: "5901234123785",
    },
    {
      code: "STK035",
      description: "Binder Clips Assorted (Box of 100)",
      category: "Office Supplies",
      location: "Retail Store",
      physicalQuantity: 190,
      unitPrice: 7.99,
      inactive: false,
      barcode: "5901234123792",
    },
    {
      code: "STK036",
      description: "Ceramic Tiles 30x30cm",
      category: "Raw Materials",
      location: "Distribution Center",
      physicalQuantity: 500,
      unitPrice: 4.25,
      inactive: false,
      barcode: "5901234123808",
    },
    {
      code: "STK037",
      description: "Printer Laser Brother",
      category: "Electronics",
      location: "Warehouse A",
      physicalQuantity: 25,
      unitPrice: 299.99,
      inactive: false,
      barcode: "5901234123815",
    },
    {
      code: "STK038",
      description: "Executive Desk L-Shaped",
      category: "Furniture",
      location: "Warehouse B",
      physicalQuantity: 18,
      unitPrice: 749.0,
      inactive: false,
      barcode: "5901234123822",
    },
    {
      code: "STK039",
      description: "Calculator Scientific",
      category: "Office Supplies",
      location: "Warehouse A",
      physicalQuantity: 130,
      unitPrice: 24.99,
      inactive: false,
      barcode: "5901234123839",
    },
    {
      code: "STK040",
      description: "Glass Sheets 4mm Tempered",
      category: "Raw Materials",
      location: "Warehouse C",
      physicalQuantity: 80,
      unitPrice: 125.0,
      inactive: true,
      barcode: "5901234123846",
    },
    {
      code: "STK041",
      description: "Power Drill Cordless",
      category: "Tools",
      location: "Warehouse A",
      physicalQuantity: 55,
      unitPrice: 159.99,
      inactive: false,
      barcode: "5901234123853",
    },
    {
      code: "STK042",
      description: "Toolbox Metal 5-Drawer",
      category: "Tools",
      location: "Warehouse B",
      physicalQuantity: 40,
      unitPrice: 189.99,
      inactive: false,
      barcode: "5901234123860",
    },
    {
      code: "STK043",
      description: "Screwdriver Set 20-Piece",
      category: "Tools",
      location: "Retail Store",
      physicalQuantity: 95,
      unitPrice: 39.99,
      inactive: false,
      barcode: "5901234123877",
    },
    {
      code: "STK044",
      description: "Cardboard Boxes Large (Pack of 25)",
      category: "Packaging",
      location: "Warehouse A",
      physicalQuantity: 350,
      unitPrice: 29.99,
      inactive: false,
      barcode: "5901234123884",
    },
    {
      code: "STK045",
      description: "Bubble Wrap Roll 50m",
      category: "Packaging",
      location: "Distribution Center",
      physicalQuantity: 180,
      unitPrice: 18.5,
      inactive: false,
      barcode: "5901234123891",
    },
    {
      code: "STK046",
      description: "Packing Tape Clear (6-Pack)",
      category: "Packaging",
      location: "Warehouse A",
      physicalQuantity: 240,
      unitPrice: 12.99,
      inactive: false,
      barcode: "5901234123907",
    },
    {
      code: "STK047",
      description: "Safety Goggles Anti-Fog",
      category: "Safety Equipment",
      location: "Warehouse C",
      physicalQuantity: 150,
      unitPrice: 14.99,
      inactive: false,
      barcode: "5901234123914",
    },
    {
      code: "STK048",
      description: "Hard Hat Yellow",
      category: "Safety Equipment",
      location: "Warehouse B",
      physicalQuantity: 200,
      unitPrice: 19.99,
      inactive: false,
      barcode: "5901234123921",
    },
    {
      code: "STK049",
      description: "Safety Gloves Cut-Resistant",
      category: "Safety Equipment",
      location: "Warehouse A",
      physicalQuantity: 300,
      unitPrice: 8.99,
      inactive: false,
      barcode: "5901234123938",
    },
    {
      code: "STK050",
      description: "Fire Extinguisher 5kg",
      category: "Safety Equipment",
      location: "Retail Store",
      physicalQuantity: 45,
      unitPrice: 89.99,
      inactive: false,
      barcode: "5901234123945",
    },
    {
      code: "STK051",
      description: "Label Maker Portable",
      category: "Office Supplies",
      location: "Warehouse A",
      physicalQuantity: 60,
      unitPrice: 49.99,
      inactive: false,
      barcode: "5901234123952",
    },
    {
      code: "STK052",
      description: "Shredder Cross-Cut",
      category: "Office Supplies",
      location: "Warehouse B",
      physicalQuantity: 28,
      unitPrice: 129.99,
      inactive: false,
      barcode: "5901234123969",
    },
    {
      code: "STK053",
      description: "Laminator A4",
      category: "Office Supplies",
      location: "Retail Store",
      physicalQuantity: 35,
      unitPrice: 69.99,
      inactive: false,
      barcode: "5901234123976",
    },
    {
      code: "STK054",
      description: "Paint Rollers (Set of 5)",
      category: "Tools",
      location: "Warehouse C",
      physicalQuantity: 120,
      unitPrice: 22.99,
      inactive: false,
      barcode: "5901234123983",
    },
    {
      code: "STK055",
      description: "Measuring Tape 10m",
      category: "Tools",
      location: "Warehouse A",
      physicalQuantity: 85,
      unitPrice: 12.99,
      inactive: false,
      barcode: "5901234123990",
    },
    // Manufacturing Components for BOMs
    {
      code: "DESK-001",
      description: "Executive Desk",
      category: "Finished Goods",
      location: "Warehouse A",
      physicalQuantity: 15,
      unitPrice: 749.00,
      inactive: false,
      barcode: "5901234124003",
    },
    {
      code: "WOOD-OAK-001",
      description: "Oak Wood Panel 2000x800mm",
      category: "Raw Materials",
      location: "Warehouse C",
      physicalQuantity: 45,
      unitPrice: 85.00,
      inactive: false,
      barcode: "5901234124010",
    },
    {
      code: "WOOD-OAK-002",
      description: "Oak Wood Legs",
      category: "Components",
      location: "Warehouse C",
      physicalQuantity: 120,
      unitPrice: 22.50,
      inactive: false,
      barcode: "5901234124027",
    },
    {
      code: "HARDWARE-001",
      description: "Drawer Slides Heavy Duty",
      category: "Components",
      location: "Warehouse A",
      physicalQuantity: 200,
      unitPrice: 8.50,
      inactive: false,
      barcode: "5901234124034",
    },
    {
      code: "HARDWARE-002",
      description: "Drawer Handles Brass",
      category: "Components",
      location: "Warehouse A",
      physicalQuantity: 350,
      unitPrice: 4.25,
      inactive: false,
      barcode: "5901234124041",
    },
    {
      code: "FINISH-001",
      description: "Wood Varnish Premium",
      category: "Raw Materials",
      location: "Warehouse C",
      physicalQuantity: 25,
      unitPrice: 28.00,
      inactive: false,
      barcode: "5901234124058",
    },
    {
      code: "CHAIR-001",
      description: "Office Chair Ergonomic",
      category: "Finished Goods",
      location: "Warehouse B",
      physicalQuantity: 30,
      unitPrice: 249.50,
      inactive: false,
      barcode: "5901234124065",
    },
    {
      code: "CHAIR-BASE-001",
      description: "Chair Base Assembly 5-Star",
      category: "Components",
      location: "Warehouse B",
      physicalQuantity: 80,
      unitPrice: 35.00,
      inactive: false,
      barcode: "5901234124072",
    },
    {
      code: "CHAIR-CYLINDER-001",
      description: "Gas Lift Cylinder",
      category: "Components",
      location: "Warehouse B",
      physicalQuantity: 150,
      unitPrice: 18.50,
      inactive: false,
      barcode: "5901234124089",
    },
    {
      code: "CHAIR-SEAT-001",
      description: "Chair Seat Cushion",
      category: "Components",
      location: "Warehouse B",
      physicalQuantity: 100,
      unitPrice: 42.00,
      inactive: false,
      barcode: "5901234124096",
    },
    {
      code: "CHAIR-BACK-001",
      description: "Chair Backrest Assembly",
      category: "Components",
      location: "Warehouse B",
      physicalQuantity: 95,
      unitPrice: 38.50,
      inactive: false,
      barcode: "5901234124102",
    },
    {
      code: "CHAIR-ARMREST-001",
      description: "Chair Armrests Pair",
      category: "Components",
      location: "Warehouse B",
      physicalQuantity: 110,
      unitPrice: 28.00,
      inactive: false,
      barcode: "5901234124119",
    },
    {
      code: "LAPTOP-001",
      description: "Business Laptop 15 inch",
      category: "Finished Goods",
      location: "Warehouse A",
      physicalQuantity: 20,
      unitPrice: 899.00,
      inactive: false,
      barcode: "5901234124126",
    },
    {
      code: "LCD-SCREEN-001",
      description: "LCD Screen 15.6 inch FHD",
      category: "Components",
      location: "Warehouse A",
      physicalQuantity: 50,
      unitPrice: 125.00,
      inactive: false,
      barcode: "5901234124133",
    },
    {
      code: "MOTHERBOARD-001",
      description: "Laptop Motherboard i5",
      category: "Components",
      location: "Warehouse A",
      physicalQuantity: 45,
      unitPrice: 185.00,
      inactive: false,
      barcode: "5901234124140",
    },
    {
      code: "BATTERY-001",
      description: "Laptop Battery 6-Cell",
      category: "Components",
      location: "Warehouse A",
      physicalQuantity: 80,
      unitPrice: 45.00,
      inactive: false,
      barcode: "5901234124157",
    },
    {
      code: "KEYBOARD-KB-001",
      description: "Laptop Keyboard Backlit",
      category: "Components",
      location: "Warehouse A",
      physicalQuantity: 60,
      unitPrice: 28.00,
      inactive: false,
      barcode: "5901234124164",
    },
    {
      code: "CHASSIS-001",
      description: "Laptop Chassis Aluminum",
      category: "Raw Materials",
      location: "Warehouse A",
      physicalQuantity: 55,
      unitPrice: 65.00,
      inactive: false,
      barcode: "5901234124171",
    },
    {
      code: "TABLE-001",
      description: "Conference Table 8-Seater",
      category: "Finished Goods",
      location: "Warehouse B",
      physicalQuantity: 8,
      unitPrice: 1299.00,
      inactive: false,
      barcode: "5901234124188",
    },
    {
      code: "TABLETOP-001",
      description: "Table Top Oak 2400x1200mm",
      category: "Raw Materials",
      location: "Warehouse C",
      physicalQuantity: 20,
      unitPrice: 285.00,
      inactive: false,
      barcode: "5901234124195",
    },
    {
      code: "TABLE-LEG-001",
      description: "Table Leg Metal Adjustable",
      category: "Raw Materials",
      location: "Warehouse C",
      physicalQuantity: 100,
      unitPrice: 35.00,
      inactive: false,
      barcode: "5901234124201",
    },
    {
      code: "CABLE-MGMT-001",
      description: "Cable Management System",
      category: "Raw Materials",
      location: "Warehouse A",
      physicalQuantity: 40,
      unitPrice: 18.50,
      inactive: false,
      barcode: "5901234124218",
    },
    {
      code: "BOOKSHELF-001",
      description: "Bookshelf 5-Tier Modern",
      category: "Finished Goods",
      location: "Warehouse B",
      physicalQuantity: 25,
      unitPrice: 189.00,
      inactive: false,
      barcode: "5901234124225",
    },
    {
      code: "SHELF-BOARD-001",
      description: "Shelf Board Pine 800x300mm",
      category: "Raw Materials",
      location: "Warehouse C",
      physicalQuantity: 150,
      unitPrice: 12.50,
      inactive: false,
      barcode: "5901234124232",
    },
    {
      code: "SHELF-BRACKET-001",
      description: "Shelf Bracket Metal L-Shape",
      category: "Raw Materials",
      location: "Warehouse A",
      physicalQuantity: 300,
      unitPrice: 3.50,
      inactive: false,
      barcode: "5901234124249",
    },
    {
      code: "WOOD-SCREW-001",
      description: "Wood Screws 4x40mm Box 100",
      category: "Raw Materials",
      location: "Warehouse A",
      physicalQuantity: 500,
      unitPrice: 5.99,
      inactive: false,
      barcode: "5901234124256",
    },
    {
      code: "MONITOR-001",
      description: "Monitor 27 inch 4K Professional",
      category: "Finished Goods",
      location: "Warehouse A",
      physicalQuantity: 18,
      unitPrice: 549.00,
      inactive: false,
      barcode: "5901234124263",
    },
    {
      code: "MONITOR-PANEL-001",
      description: "LCD Panel 27 inch 4K",
      category: "Raw Materials",
      location: "Warehouse A",
      physicalQuantity: 35,
      unitPrice: 185.00,
      inactive: false,
      barcode: "5901234124270",
    },
    {
      code: "MONITOR-STAND-001",
      description: "Monitor Stand Adjustable",
      category: "Raw Materials",
      location: "Warehouse A",
      physicalQuantity: 50,
      unitPrice: 28.00,
      inactive: false,
      barcode: "5901234124287",
    },
    {
      code: "POWER-SUPPLY-001",
      description: "Power Supply 65W",
      category: "Raw Materials",
      location: "Warehouse A",
      physicalQuantity: 100,
      unitPrice: 22.00,
      inactive: false,
      barcode: "5901234124294",
    },
    {
      code: "HDMI-CABLE-001",
      description: "HDMI Cable 2m",
      category: "Raw Materials",
      location: "Warehouse A",
      physicalQuantity: 200,
      unitPrice: 8.50,
      inactive: false,
      barcode: "5901234124300",
    },
  ];

  // Calculate value and add random dates and quantity fields
  const stockItems = items.map((item) => {
    const daysAgo = Math.floor(Math.random() * 90); // Random date within last 90 days
    const lastMovementDate = new Date();
    lastMovementDate.setDate(lastMovementDate.getDate() - daysAgo);

    // Generate quantity fields based on requirements
    const allocatedQuantity = Math.floor(item.physicalQuantity * (Math.random() * 0.5)); // 0-50% of physical
    const quantityDueIn = Math.floor(Math.random() * 100); // 0-100
    const minQuantity = Math.floor(Math.random() * 40) + 10; // 10-50
    const maxQuantity = Math.floor(Math.random() * 400) + 100; // 100-500
    const reorderPoint = Math.floor(minQuantity + (maxQuantity - minQuantity) * 0.3); // Between min and max

    // Generate pricing fields based on requirements
    const lastCostPrice = parseFloat((item.unitPrice * (0.8 + Math.random() * 0.1)).toFixed(2)); // 80-90% of unit price
    const averageCost = parseFloat((item.unitPrice * (0.75 + Math.random() * 0.15)).toFixed(2)); // 75-90% of unit price
    const totalCostOfSales = parseFloat((Math.random() * 490000 + 10000).toFixed(2)); // £10,000 - £500,000
    const totalValueOfSales = parseFloat((totalCostOfSales * (1.2 + Math.random() * 0.3)).toFixed(2)); // 20-50% margin

    // Generate analysis codes
    const purchaseAnalysisCodes = ["PUR-001", "PUR-ELC", "PUR-FUR", "PUR-OFF", "PUR-RAW", "PUR-TOL", "PUR-SAF"];
    const salesAnalysisCodes = ["SAL-RET", "SAL-WHL", "SAL-ONL", "SAL-EXP", "SAL-DOM"];
    const movementInCodes = ["MI-STD", "MI-RET", "MI-TRF", "MI-ADJ", "MI-PUR"];
    const movementOutCodes = ["MO-SAL", "MO-ADJ", "MO-TRF", "MO-WAS", "MO-RET"];

    const purchaseAnalysisCode = purchaseAnalysisCodes[Math.floor(Math.random() * purchaseAnalysisCodes.length)];
    const salesAnalysisCode = salesAnalysisCodes[Math.floor(Math.random() * salesAnalysisCodes.length)];
    const movementInAnalysis = movementInCodes[Math.floor(Math.random() * movementInCodes.length)];
    const movementOutAnalysis = movementOutCodes[Math.floor(Math.random() * movementOutCodes.length)];

    // Generate ABC classification (20% A, 30% B, 50% C)
    const rand = Math.random();
    const abcClassification: "A" | "B" | "C" = rand < 0.2 ? "A" : rand < 0.5 ? "B" : "C";

    // Generate stock turn rate (0.5 - 12.0)
    const stockTurnRate = parseFloat((Math.random() * 11.5 + 0.5).toFixed(1));

    // Generate supplier data
    const suppliers = [
      "ABC Electronics Ltd",
      "Global Furniture Co",
      "Office Depot Inc",
      "TechSupply Solutions",
      "Industrial Materials Group",
      "Premier Office Supplies",
      "BuildMart Wholesale",
      "Quality Tools & Equipment",
      "SafetyFirst Supplies",
      "PackagePro Distributors",
      "MetalWorks International",
      "Furniture Direct Ltd",
      "ElectroTech Suppliers",
      "Office Essentials Co",
      "Hardware & More Inc",
    ];

    // 80% of items have a supplier
    const hasSupplier = Math.random() < 0.8;
    const supplier = hasSupplier ? suppliers[Math.floor(Math.random() * suppliers.length)] : undefined;
    const leadTimeDays = hasSupplier ? Math.floor(Math.random() * 30) + 1 : undefined; // 1-30 days

    // Generate purchase date (last 6 months or null)
    const hasPurchaseHistory = hasSupplier && Math.random() < 0.85;
    let lastPurchaseDate: Date | null = null;
    if (hasPurchaseHistory) {
      const purchaseDaysAgo = Math.floor(Math.random() * 180); // 0-180 days (6 months)
      lastPurchaseDate = new Date();
      lastPurchaseDate.setDate(lastPurchaseDate.getDate() - purchaseDaysAgo);
    }

    // Generate sale date (last 3 months or null)
    const hasSaleHistory = Math.random() < 0.9;
    let lastSaleDate: Date | null = null;
    if (hasSaleHistory) {
      const saleDaysAgo = Math.floor(Math.random() * 90); // 0-90 days (3 months)
      lastSaleDate = new Date();
      lastSaleDate.setDate(lastSaleDate.getDate() - saleDaysAgo);
    }

    // Generate supplier contact email
    const supplierContact = hasSupplier ? `orders@${supplier?.toLowerCase().replace(/[^a-z0-9]/g, "")}.com` : undefined;

    // Generate purchase history data
    const lastPurchaseQuantity = hasPurchaseHistory ? Math.floor(Math.random() * 190) + 10 : undefined; // 10-200
    const lastPurchasePrice = hasPurchaseHistory
      ? parseFloat((lastCostPrice * (0.95 + Math.random() * 0.1)).toFixed(2))
      : undefined;

    // Generate sales history data
    const lastSaleQuantity = hasSaleHistory ? Math.floor(Math.random() * 50) + 1 : undefined; // 1-50
    const lastSalePrice = hasSaleHistory
      ? parseFloat((item.unitPrice * (0.95 + Math.random() * 0.1)).toFixed(2))
      : undefined;

    // Generate supplier performance metrics
    const onTimeDeliveryRate = hasSupplier ? parseFloat((85 + Math.random() * 13).toFixed(1)) : undefined; // 85-98%
    const averageLeadTime =
      hasSupplier && leadTimeDays ? Math.floor(leadTimeDays + (Math.random() * 4 - 2)) : undefined; // leadTimeDays ± 2
    const totalOrdersYTD = hasSupplier ? Math.floor(Math.random() * 46) + 5 : undefined; // 5-50

    // Map old location string to warehouse code and randomly assign location codes
    // This distributes stock items across multiple locations within each warehouse
    const locationsByWarehouse: { [key: string]: { warehouseCode: string; locationCodes: string[] } } = {
      "Warehouse A": { 
        warehouseCode: "WH-A", 
        locationCodes: [
          "A01-R01-S01-B01", "A01-R01-S01-B02", "A01-R01-S02-B01", "A01-R01-S02-B02",
          "A01-R02-S01-B01", "A01-R02-S01-B02", "A02-R01-S01-B01", "A02-R01-S01-B02",
          "A02-R01-S02-B01", "A02-R02-S01-B01", "A03-R01-S01-B01", "A03-R01-S02-B01"
        ]
      },
      "Warehouse B": { 
        warehouseCode: "WH-B", 
        locationCodes: [
          "B01-R01-B01", "B01-R02-B02", "B01-R03-B03", "B01-R04-B04", "B01-R05-B05",
          "B02-R01-B01", "B02-R02-B02", "B02-R03-B03", "B03-R01-B01", "B03-R02-B02",
          "B04-R01-B01", "B04-R02-B02"
        ]
      },
      "Warehouse C": { 
        warehouseCode: "WH-C", 
        locationCodes: [
          "C01-MAIN", "C02-MAIN", "C03-MAIN", "C04-MAIN", "C05-MAIN",
          "C06-MAIN", "C07-MAIN", "C08-MAIN"
        ]
      },
      "Retail Store": { 
        warehouseCode: "RS", 
        locationCodes: [
          "RS-MAIN", "RS-BACK", "RS-DISPLAY", "RS-COUNTER", "RS-STOCK-A", "RS-STOCK-B"
        ]
      },
      "Distribution Center": { 
        warehouseCode: "DC", 
        locationCodes: [
          "DC-RCV-01", "DC-RCV-02", "DC-STG-01", "DC-STG-02", "DC-PCK-01", 
          "DC-PCK-02", "DC-PCK-03", "DC-SHP-01", "DC-SHP-02"
        ]
      },
      "Storage Room": { 
        warehouseCode: "SR", 
        locationCodes: ["SR-01", "SR-02", "SR-03", "SR-04", "SR-05"]
      },
    };

    const warehouseData = locationsByWarehouse[item.location] || locationsByWarehouse["Warehouse A"];
    const randomLocationCode = warehouseData.locationCodes[Math.floor(Math.random() * warehouseData.locationCodes.length)];
    const mappedLocation = { warehouseCode: warehouseData.warehouseCode, locationCode: randomLocationCode };

    // Assign UOM based on category
    const uomMapping: { [key: string]: "Each" | "Box/Carton" | "Kg" | "g" | "Litre" | "Metre" | "Pallet" } = {
      Electronics: "Each",
      Furniture: "Each",
      "Office Supplies": "Box/Carton",
      "Raw Materials": "Kg",
      Components: "Each",
      Tools: "Each",
      "Safety Equipment": "Each",
      Packaging: "Box/Carton",
    };
    const unitOfMeasure = uomMapping[item.category] || "Each";

    // Assign currencies - some items in foreign currencies for demo
    const currencies = ["GBP", "USD", "EUR", "JPY", "AUD", "CAD"];
    const randomCurrency = Math.random() > 0.7 ? currencies[Math.floor(Math.random() * currencies.length)] : "GBP";
    
    // Determine assembly/component flags based on item code and category
    // Finished Goods = Assemblies (can be assembled from components)
    // Raw Materials & Components = Can be used in other assemblies
    const finishedGoodsCodes = ["DESK-001", "CHAIR-001", "LAPTOP-001", "TABLE-001", "BOOKSHELF-001", "MONITOR-001"];
    const isFinishedGood = finishedGoodsCodes.includes(item.code);
    const isRawMaterial = item.category === "Raw Materials" || item.category === "Components";
    
    return {
      code: item.code,
      description: item.description,
      category: item.category,
      unitOfMeasure,
      physicalQuantity: item.physicalQuantity,
      unitPrice: item.unitPrice,
      unitPriceCurrency: randomCurrency,
      inactive: item.inactive,
      barcode: item.barcode,
      warehouseCode: mappedLocation.warehouseCode,
      locationCode: mappedLocation.locationCode,
      value: item.physicalQuantity * item.unitPrice,
      lastMovementDate,
      allocatedQuantity,
      quantityDueIn,
      minQuantity,
      maxQuantity,
      reorderPoint,
      reorderQuantity: Math.floor(Math.random() * 100) + 50, // 50-150
      lastCostPrice,
      lastCostPriceCurrency: randomCurrency,
      averageCost,
      averageCostCurrency: "GBP", // Average cost always in home currency
      totalCostOfSales,
      totalValueOfSales,
      purchaseAnalysisCode,
      salesAnalysisCode,
      movementInAnalysis,
      movementOutAnalysis,
      abcClassification,
      stockTurnRate,
      supplier,
      leadTimeDays,
      lastPurchaseDate,
      lastSaleDate,
      supplierContact,
      lastPurchaseQuantity,
      lastPurchasePrice,
      lastPurchasePriceCurrency: randomCurrency,
      lastSaleQuantity,
      lastSalePrice,
      lastSalePriceCurrency: "GBP",
      onTimeDeliveryRate,
      averageLeadTime,
      totalOrdersYTD,
      transactionCount: getTransactionCount(item.code),
      // Assembly/Component flags for manufacturing
      isAssembly: isFinishedGood, // Finished goods can be assembled from components
      isComponent: isRawMaterial, // Raw materials can be used in other assemblies
      allowDisassembly: isFinishedGood, // Finished goods can be broken down into components
      isSellable: !isRawMaterial, // Raw materials are not sold directly
      isPurchasable: isRawMaterial, // Raw materials are purchased, finished goods are manufactured
    };
  });

  // Add multi-location distribution for specific items (STK001, STK002, STK009, STK013, STK021)
  // This demonstrates items stored across multiple warehouses
  const multiLocationItems = ["STK001", "STK002", "STK009", "STK013", "STK021"];
  
  return stockItems.map((item) => {
    if (!multiLocationItems.includes(item.code)) {
      return item;
    }

    // Create multi-location distribution for these items
    let locationQuantities: LocationQuantity[] = [];
    
    if (item.code === "STK001") {
      // Laptop Dell XPS 15 - distributed across 3 locations
      locationQuantities = [
        { warehouseCode: "WH-A", locationCode: "A01-R01-S01-B01", quantity: 15, allocated: 5, dueIn: 10, warehouseName: "Warehouse A", locationName: "A01-R01-S01-B01" },
        { warehouseCode: "WH-B", locationCode: "B01-R02-B02", quantity: 20, allocated: 8, dueIn: 15, warehouseName: "Warehouse B", locationName: "B01-R02-B02" },
        { warehouseCode: "RS", locationCode: "RS-DISPLAY", quantity: 10, allocated: 3, dueIn: 0, warehouseName: "Retail Store", locationName: "RS-DISPLAY" },
      ];
    } else if (item.code === "STK002") {
      // Office Chair - distributed across 2 locations
      locationQuantities = [
        { warehouseCode: "WH-A", locationCode: "A02-R01-S01-B01", quantity: 70, allocated: 20, dueIn: 30, warehouseName: "Main Warehouse", locationName: "A02-R01-S01-B01" },
        { warehouseCode: "WH-B", locationCode: "B02-R01-B01", quantity: 50, allocated: 15, dueIn: 20, warehouseName: "Satellite Warehouse", locationName: "B02-R01-B01" },
      ];
    } else if (item.code === "STK009") {
      // Monitor 27" 4K - distributed across 4 locations
      locationQuantities = [
        { warehouseCode: "WH-A", locationCode: "A01-R01-S02-B01", quantity: 25, allocated: 10, dueIn: 5, warehouseName: "Main Warehouse", locationName: "A01-R01-S02-B01" },
        { warehouseCode: "WH-B", locationCode: "B01-R03-B03", quantity: 15, allocated: 5, dueIn: 10, warehouseName: "Satellite Warehouse", locationName: "B01-R03-B03" },
        { warehouseCode: "RS", locationCode: "RS-DISPLAY", quantity: 10, allocated: 8, dueIn: 0, warehouseName: "Retail Store", locationName: "RS-DISPLAY" },
        { warehouseCode: "DC", locationCode: "DC-STG-01", quantity: 10, allocated: 0, dueIn: 20, warehouseName: "Distribution Center", locationName: "DC-STG-01" },
      ];
    } else if (item.code === "STK013") {
      // Keyboard Mechanical RGB - distributed across 3 locations
      locationQuantities = [
        { warehouseCode: "WH-A", locationCode: "A01-R02-S01-B01", quantity: 30, allocated: 12, dueIn: 25, warehouseName: "Main Warehouse", locationName: "A01-R02-S01-B01" },
        { warehouseCode: "RS", locationCode: "RS-STOCK-A", quantity: 25, allocated: 10, dueIn: 0, warehouseName: "Retail Store", locationName: "RS-STOCK-A" },
        { warehouseCode: "DC", locationCode: "DC-PCK-01", quantity: 15, allocated: 5, dueIn: 15, warehouseName: "Distribution Center", locationName: "DC-PCK-01" },
      ];
    } else if (item.code === "STK021") {
      // USB-C Hub - distributed across 2 locations
      locationQuantities = [
        { warehouseCode: "WH-A", locationCode: "A03-R01-S01-B01", quantity: 50, allocated: 18, dueIn: 30, warehouseName: "Main Warehouse", locationName: "A03-R01-S01-B01" },
        { warehouseCode: "RS", locationCode: "RS-COUNTER", quantity: 40, allocated: 15, dueIn: 10, warehouseName: "Retail Store", locationName: "RS-COUNTER" },
      ];
    }

    // Update the item with location quantities
    // Set primary location to the first location in the array
    return {
      ...item,
      locationQuantities,
      warehouseCode: locationQuantities[0].warehouseCode,
      locationCode: locationQuantities[0].locationCode,
      physicalQuantity: locationQuantities.reduce((sum, loc) => sum + loc.quantity, 0),
    };
  });
};

// Export a constant array for components that need static data
// This includes multi-location distribution for STK001, STK002, STK009, STK013, STK021
export const mockStockItems = generateMockStockItems().map((item) => {
  // Add sample relationships for demonstration
  if (item.code === "STK001") {
    // Laptop Dell XPS 15 - has alternatives and linked items
    return {
      ...item,
      alternativeItems: [
        {
          id: "alt-stk001-1",
          stockCode: "STK033",
          description: 'Tablet iPad 10.2"',
          unitPrice: 449.0,
          physicalQuantity: 35,
          category: "Electronics",
        },
      ],
      linkedItems: [
        {
          id: "link-stk001-1",
          stockCode: "STK005",
          description: "Wireless Mouse Logitech",
          relationshipType: "Accessory" as const,
          unitPrice: 29.99,
          physicalQuantity: 85,
          category: "Electronics",
        },
        {
          id: "link-stk001-2",
          stockCode: "STK013",
          description: "Keyboard Mechanical RGB",
          relationshipType: "Accessory" as const,
          unitPrice: 129.99,
          physicalQuantity: 70,
          category: "Electronics",
        },
        {
          id: "link-stk001-3",
          stockCode: "STK025",
          description: "External SSD 1TB Samsung",
          relationshipType: "Complementary" as const,
          unitPrice: 149.99,
          physicalQuantity: 40,
          category: "Electronics",
        },
      ],
    };
  }
  
  if (item.code === "STK009") {
    // Monitor 27" 4K - has alternatives and linked items
    return {
      ...item,
      alternativeItems: [
        {
          id: "alt-stk009-1",
          stockCode: "STK001",
          description: "Laptop Dell XPS 15",
          unitPrice: 1299.99,
          physicalQuantity: 45,
          category: "Electronics",
        },
      ],
      linkedItems: [
        {
          id: "link-stk009-1",
          stockCode: "STK013",
          description: "Keyboard Mechanical RGB",
          relationshipType: "Accessory" as const,
          unitPrice: 129.99,
          physicalQuantity: 70,
          category: "Electronics",
        },
        {
          id: "link-stk009-2",
          stockCode: "STK005",
          description: "Wireless Mouse Logitech",
          relationshipType: "Accessory" as const,
          unitPrice: 29.99,
          physicalQuantity: 85,
          category: "Electronics",
        },
      ],
    };
  }
  
  if (item.code === "STK002") {
    // Office Chair - has alternatives
    return {
      ...item,
      alternativeItems: [
        {
          id: "alt-stk002-1",
          stockCode: "STK034",
          description: "Visitor Chair Stackable",
          unitPrice: 79.99,
          physicalQuantity: 200,
          category: "Furniture",
        },
      ],
      linkedItems: [
        {
          id: "link-stk002-1",
          stockCode: "STK006",
          description: "Standing Desk Adjustable",
          relationshipType: "Complementary" as const,
          unitPrice: 599.0,
          physicalQuantity: 35,
          category: "Furniture",
        },
      ],
    };
  }
  
  if (item.code === "STK037") {
    // Printer Laser Brother - has linked items (consumables)
    return {
      ...item,
      linkedItems: [
        {
          id: "link-stk037-1",
          stockCode: "STK003",
          description: "A4 Paper Ream (500 sheets)",
          relationshipType: "Complementary" as const,
          unitPrice: 5.99,
          physicalQuantity: 450,
          category: "Office Supplies",
        },
        {
          id: "link-stk037-2",
          stockCode: "STK019",
          description: "Printer Paper A3 (250 sheets)",
          relationshipType: "Complementary" as const,
          unitPrice: 9.99,
          physicalQuantity: 220,
          category: "Office Supplies",
        },
      ],
    };
  }
  
  if (item.code === "STK041") {
    // Power Drill - has linked items (accessories and spare parts)
    return {
      ...item,
      linkedItems: [
        {
          id: "link-stk041-1",
          stockCode: "STK043",
          description: "Screwdriver Set 20-Piece",
          relationshipType: "Related Product" as const,
          unitPrice: 39.99,
          physicalQuantity: 95,
          category: "Tools",
        },
        {
          id: "link-stk041-2",
          stockCode: "STK047",
          description: "Safety Goggles Anti-Fog",
          relationshipType: "Accessory" as const,
          unitPrice: 14.99,
          physicalQuantity: 150,
          category: "Safety Equipment",
        },
      ],
    };
  }
  
  return item;
});
